import React from 'react';

import { Image, Text } from '@change/ds-core-ui';

import emptyCtaPanelImage from 'src/assets/supporterVoices/cta-comms-image.png';

type Props = {
	message: string;
	callToActionSlot?: React.JSX.Element;
};

export function EmptyStateCtaPanel({ message, callToActionSlot }: Props): React.JSX.Element | null {
	return (
		<div className="rounded-large elevation-low flex max-w-[628px] shrink-0 flex-col items-center justify-center gap-4 p-6 text-center">
			<Image src={emptyCtaPanelImage} aria-hidden className="h-[104px] w-[114px] object-cover" />
			<Text size="large">{message}</Text>
			{callToActionSlot}
		</div>
	);
}
